import { IAccount, IClientSource, IFormFieldInfo, IProductType, IValidation, Locale, Uuid } from "@lib";
import { Control } from "@core/components/alt-ui/controls";

export type FormFieldControlContext = {
    locale?: Locale;
    clientSources?: IClientSource[];
    productTypes?: IProductType[];
    accounts?: IAccount[];
};

export abstract class FormFieldControl<TControl = Control> {
    protected readonly context?: FormFieldControlContext;
    public readonly field: IFormFieldInfo;
    public readonly control: TControl;

    public constructor(field: IFormFieldInfo, context?: FormFieldControlContext) {
        this.context = context;
        this.field = field;
        this.control = this.convert();
    }

    protected abstract convert(): TControl;

    public get id(): string {
        return this.field.id ?? Uuid.short();
    }

    public get value(): any {
        return null;
    }

    public set value(value: any) {
        //
    }

    public get hasValue(): boolean {
        return !!this.value;
    }

    public getValueFormatted(): string {
        return this.value ? String(this.value) : "";
    }

    protected validationToString(validation?: IValidation): string {
        if (!validation) {
            return "";
        }

        let result = "";
        if (validation.required) {
            if (result.length > 0) {
                result += "|";
            }
            result += "required";
        }
        if (validation.email) {
            if (result.length > 0) {
                result += "|";
            }
            result += "email";
        }
        if (validation.money) {
            if (result.length > 0) {
                result += "|";
            }
            result += "money";
        }
        if (validation.unsigned) {
            if (result.length > 0) {
                result += "|";
            }
            result += "unsigned";
        }

        return result;
    }
}
